import { NotificationBox, NotificationContent } from '@components/_Revamp/NotificationBox'
import React from 'react'

export interface MaintenanceMessageBoxProps {
  children: React.ReactNode;
}

const MaintenanceMessageBox = ({children}:MaintenanceMessageBoxProps) => {
  return (
    <NotificationBox margin={"0 0 24px"}>
      <NotificationContent>
        {children}
      </NotificationContent>
    </NotificationBox>
  )
}

export default MaintenanceMessageBox